{
  "age": {
    "years": ["junior", "adult", "senior", "elderly"]
  },

  "gewicht": {
    "bmi": ["healthy", "underweight", "overweight", "obese", "unknown"]
  },

  "gender": {
    "bio": ["male", "female", "fluent"]
  },

  "lab": {
    "elektrolyt": ["yes", "no", "unknown"],
    "entzündung": ["yes", "no", "unknown"]
  },
  "elektrolyt": {
    "kalium": ["low", "normal", "high", "unknown"],
    "magnesium": ["low", "normal", "high", "unknown"],
    "calcium": ["low", "normal", "high", "unknown"]
  },
  "entzündung": {
    "crp": ["low", "normal", "high", "unknown"],
    "bsg": ["low", "normal", "high", "unknown"]
  },

  "organ": {
    "renal": ["yes", "no", "unknown"],
    "liver": ["yes", "no", "unknown"]
  },
  "renal": {
    "gfr": ["15", "30", "60", "90", "120", "unknown"]
  },
  "liver": {
    "stage": ["normal", "impaired", "failure", "unknown"]
  },

  "ekg": {
    "qtc": ["normal", "mt450", "mt470", "unknown"]
  },

  "disease": {
    "heartdisease": ["yes", "no", "unknown"],
    "metabolic": ["yes", "no", "unknown"],
    "neurologic": ["yes", "no", "unknown"]
  },
  "heartdisease": {
    "hypertension": ["yes", "no", "last5years", "unknown"],
    "arrhythmia": ["yes", "no", "last5years", "unknown"],
    "cardiomyopathy": ["yes", "no", "last5years", "unknown"],
    "ejectionfraction": ["yes", "no", "last5years", "unknown"]
  },
  "metabolic": {
    "diabetes": ["yes", "no", "unknown"],
    "thyroid": ["yes", "no", "unknown"]
  },
  "neurologic": {
    "general": ["yes", "no", "last5years", "unknown"]
  },

  "symptom": {
    "symptome": ["yes", "no"]
  },
  "symptome": {
    "kognitiv": ["yes", "no"],
    "vegetativ": ["yes", "no"],
    "gastrointestinal": ["yes", "no"],
    "neuromuskulär": ["yes", "no"]
  },
  "kognitiv": {
    "verwirrtheit": ["yes", "no", "unknown"],
    "agitation": ["yes", "no", "unknown"]
  },
  "vegetativ": {
    "hyperhidrosis": ["yes", "no", "unknown"],
    "fieber": ["yes", "no", "unknown"],
    "schüttelfrost": ["yes", "no", "unknown"],
    "diarrhoe": ["yes", "no", "unknown"]
  },
  "gastrointestinal": {
    "diarrhoe": ["yes", "no", "unknown"]
  },
  "neuromuskulär": {
    "tremor": ["yes", "no", "unknown"],
    "hyperreflexie": ["yes", "no", "unknown"],
    "myoklonus": ["yes", "no", "unknown"],
    "ataxie": ["yes", "no", "unknown"]
  },

  "gen": {
    "cytochrome": ["yes", "no"]
  },
  "cytochrome": {
    "cyp2b6": ["pm", "im", "em", "um", "unknown"],
    "cyp2d6": ["pm", "im", "em", "um", "unknown"],
    "cyp2c9": ["pm", "im", "em", "um", "unknown"],
    "cyp2c19": ["pm", "im", "em", "um", "unknown"]
  }

}